import * as types from "./featuresTypes";
import * as hospitalTypes from "./../hospital/hospitalTypes";

const initialState = {
  allFeatures: {
    loading: false,
    list: [],
    error: ""
  },
  selectedFeature: "",
  selectedFeatureBooking: "",
  featureListBooking: {
    loading: false,
    data: [],
    error: ""
  }
};

export default function featuresReducer(state = initialState, action = {}) {
  let selectedFeature = "";
  let selectedFeatureBooking: "";
  switch (action.type) {
    case types.ALL_FEATURES_IS_LOADING:
      return { ...state, allFeatures: { ...state.allFeatures, loading: true } };

    case types.REQUEST_ALL_FEATURES: {
      return {
        ...state,
        allFeatures: { ...state.allFeatures, loading: true }
      };
    }
    // Checked
    case types.REQUEST_ALL_FEATURES_SUCCESS:
      return {
        ...state,
        allFeatures: { loading: false, list: action.payload, error: "" }
      };

    // Checked
    case types.REQUEST_ALL_FEATURES_FAIL:
      return { ...state, error: action.error };

    case types.SELECT_FEATURE_BY_ID:
      selectedFeature = state.allFeatures.list.find(
        feature => feature.id === action.id
      );
      return { ...state, selectedFeature };

    case types.RESET_SELECTED_FEATURE:
      return {
        ...state,
        selectedFeature: "",
        selectedFeatureBooking: ""
      };

    // dat09 05-02-2020
    case hospitalTypes.REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_SUCCESS:
      return {
        ...state,
        featureListBooking: {
          ...state.featureList,
          data: action.data,
          loading: false
        }
      };

    case hospitalTypes.RESET_FEATURE_LIST_BY_HOSPITAL:
      return {
        ...state,
        featureListBooking: ""
      };

    case types.SELECT_FEATURE_BOOKING_BY_ID:
      selectedFeatureBooking = state.featureListBooking.data.find(
        featureBooking => featureBooking.id === action.id
      );
      return {
        ...state,
        selectedFeatureBooking
      };

    case types.RESET_FEATURE_BOOKING:
      return {
        ...state,
        selectedFeatureBooking: ""
      };
    default:
      return state;
  }
}
